var $, _;
if (typeof module === 'object' && module.exports) {
	var fetch = require('cross-fetch');
	var _ = require('underscore');
}

var Client = function Client(alternateHost, alternateProtocol) {
	var self = this;
	self.sharedHeaders = {};
	self.responseHandlers = [];

	self.alternateHost = alternateHost;
	self.alternateProtocol = alternateProtocol;
	self.errorHandler = function(error) {
		// Placeholder
		return Promise.reject(error)
	}

	function getUrlBase() {
		var protocol = self.alternateProtocol || "https";
		var host = self.alternateHost || "api.savvashortondev.com";
		return protocol + "://" + host;
	}

	// Adds an Authorization header to send along with any
	//   requests through using this instance of the client
	self.addAuth = function(value) {
		self.sharedHeaders["Authorization"] = value;
	}
	self.removeAuth = function() {
		delete self.sharedHeaders["Authorization"];
	}
	self.addResponseHandler = function(handler) {
		self.responseHandlers.push(handler);
	}
	self.resetResponseHandlers = function(value) {
		self.responseHandlers = [];
	}
	self.setErrorHandler = function(handler) {
		self.errorHandler = handler;
	}

	// api.postContacts((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postContacts = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/contacts";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getContact(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getContact = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/contacts/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchContact(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchContact = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/contacts/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postDeals((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postDeals = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/deals";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getDeal(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getDeal = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/deals/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchDeal(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchDeal = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/deals/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postEstimates((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postEstimates = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/estimates";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getEstimates((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getEstimates = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/estimates";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchEstimate(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchEstimate = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/estimates/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postInvoices((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postInvoices = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/invoices";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getInvoices((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getInvoices = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/invoices";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchInvoice(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchInvoice = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/crm/invoices/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

}

function createQueryString(queryParams) {
	var queryString ='';
	var i = 0;
	for (var queryParamName in queryParams) {
		if (i == 0) {
			queryString += '?' ;
		} else {
			queryString += '&' ;
		}
		
		queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
		i++;
	}
	
	return queryString;
}

// export module for Node.js
if (typeof module === 'object' && module.exports) {
	module.exports = Client;
}



// WEBPACK FOOTER //
// ./modules/wr_apis/apis/wr_crm_api/node_package/src/client.js